import { Logger, LoggerService } from "@Shared/logger";
import { JwtUtil } from "@Shared/utils";
import { APP_EVENTS, MNGAuthentication } from "@Core";
import { Bus, OnAuthDeterminedResult } from "@Modules/event_module";
import { Auth0Service } from "./auth0.service";

const LEGACY_EVENT_NAME = "authenticationReady";

interface LegacyAuthReadyDetail {
    isAuthenticated: boolean;
    idToken: string;
    accessToken: string;
    claims: any;
}

declare global {
    interface Window {
        MNGAuth?: any;
        MNGAuthentication?: MNGAuthentication;
        ConnextUtils?: any;
        Connext?: any;
    }
}

export class AuthCompatService {
    private static Logger: Logger = LoggerService.createLogger("AuthCompatService");
    private static initialized = false;

    static setup(): void {
        if (this.initialized) return;
        this.initialized = true;
        Bus.on(APP_EVENTS.onAuthDetermined, (result) => this.handleAuthDetermined(result));
        this.Logger.trace("AuthCompatService listening for onAuthDetermined");
    }

    private static handleAuthDetermined(result: OnAuthDeterminedResult): void {
        const repo = Auth0Service.Instance.Auth0Repo;
        const idToken = repo?.IdToken || "";
        const accessToken = repo?.AccessToken || "";
        let claims: any = null;
        if (idToken) {
            try {
                claims = JwtUtil.decodeToken(idToken);
            } catch (e) {
                this.Logger.warn("Failed to decode idToken for legacy authenticationReady event", e);
            }
        }
        const detail: LegacyAuthReadyDetail = {
            isAuthenticated: !!result?.isAuthenticated,
            idToken,
            accessToken,
            claims,
        };
        window.MNGAuth = window.MNGAuth || {};
        window.MNGAuth.authenticationReady = detail;
        window.MNGAuthentication.authenticationReady = detail;
        window.dispatchEvent(new CustomEvent(LEGACY_EVENT_NAME, { detail }));
        this.Logger.trace("Dispatched legacy authenticationReady event", detail);
    }
}
